/*eslint no-extend-native: ["error", { "exceptions": ["window","String"] }]*/
window.sleep = function (ms) {
  return new Promise(resolve => setTimeout(resolve, ms));
}

String.prototype.ucWords = function () {
  let str = this.toLowerCase()
  let re = /(^([a-zA-Z\p{M}]))|([ -][a-zA-Z\p{M}])/g
  return str.replace(re, s => s.toUpperCase())
}